module.exports = __webpack_public_path__ + "static/img/item3_1.ce29a6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dist/item3_1.png
// module id = LfKN
// module chunks = 1